/**
 * @license Copyright (c) 2012-2014 The Advisory Board Company
 */
var EABPusher = (function getPusher(Pusher) {
  var pusherInstance;

  return function getPusherInstance(key) {
    if (!pusherInstance) {
      pusherInstance = new Pusher(key, { encrypted: true });
    }
    return pusherInstance;
  };
})(Pusher);

module.exports = window.EABPusher = EABPusher;



// WEBPACK FOOTER //
// ./app/vendor/utility-pusher/src/main.js